import type { CmpHider } from './types';

export const axeptio: CmpHider = {
  id: 'axeptio',
  label: 'Axeptio',
  css: `
      /* Axeptio (axept.io CMP): the SDK (static.axept.io/sdk.js) mounts its
         entire consent UI inside a single root container "#axeptio_overlay"
         (also carrying the ".axeptio_mount" class, z-index 2147483647) appended
         to <body> — that root holds the consent widget (".axeptio_widget" /
         "#axeptio_mainDiv") and its semi-transparent dimming backdrop, so hiding
         the overlay removes the banner and the faded background in one go. After
         consent the SDK leaves a persistent fixed floating cookie button
         ("#axeptio_main_button" / ".axeptio_btn") that stays over the page, so we
         hide that too. Axeptio does not lock page scroll via a body class or
         inline style on the sites observed; if a build does, the html/html-body
         [style*="overflow"] release rule above (added for Cookiebot) already
         out-specifies an inline overflow lock and the [style*="position: fixed"]
         release above covers an inline position lock. */
      #axeptio_overlay,
      .axeptio_mount,
      .axeptio_widget,
      #axeptio_mainDiv,
      #axeptio_main_button,
      .axeptio_btn { display: none !important; }
  `,
};
